import { render, staticRenderFns } from "./management-workspace-form.vue?vue&type=template&id=5e601328&"
import script from "./management-workspace-form.vue?vue&type=script&lang=js&"
export * from "./management-workspace-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports